import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import { createVuetify } from 'vuetify';
import { satelliteOpts } from '@satellite/plugins/vuetify.js';

const opts = {
  ...satelliteOpts,
  icons: {},
  theme: {
    ...satelliteOpts.theme,
    defaultTheme: 'opendockTheme',
    themes: {
      ...(satelliteOpts.theme?.themes ?? {})
    }
  },
  customProperties: true
};

export default createVuetify(opts);
